<div class="container-delete">
  <span class="title">Eliminar cuenta</span>
  <span style="font-size: 16px; line-height: 160%">
    Una vez que elimines tu cuenta todos tus asistentes serán borrados. Esta acción es irreversible,
    por favor asegúrate.
  </span>
  <button class="btn-delete" (click)="deleteAccount()">Eliminar mi cuenta</button>
</div>
<p-confirmDialog #cd data-dialog-type="delete-account">
  <ng-template pTemplate="header">
    <h1>Lamentamos que tengas que irte :’(</h1>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      type="button"
      label="Cancelar"
      class="p-button-text"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      label="Eliminar mi cuenta de todos modos"
      class="p-button-danger"
      (click)="cd.accept()"
    ></button>
  </ng-template>
</p-confirmDialog>
